import { Component } from '@angular/core';

@Component({
  selector: 'lm-default-route',
  template: `
    <div>
      <p style="font-size:16pt; text-align: center;margin-top: 30px;">The current URL does not have an Angular Route defined.</p>
      <p style="text-align: center;">Make sure the url is properly constructed for angular routes</p>
    </div>
  `
})
export class LMDefaultRouteComponent {

  constructor() {}
}
